var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "#222222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 4.66666C4.84431 4.66697 4.69336 4.61272 4.57342 4.51333L0.573416 1.18C0.437271 1.06684 0.351655 0.904229 0.335402 0.727945C0.319148 0.551661 0.37359 0.37614 0.486749 0.239995C0.599908 0.103851 0.762515 0.0182349 0.9388 0.00198178C1.11508 -0.0142714 1.2906 0.0401696 1.42675 0.153329L5.00008 3.14L8.57342 0.259996C8.64161 0.204619 8.72007 0.163264 8.8043 0.13831C8.88853 0.113355 8.97685 0.105292 9.0642 0.114585C9.15156 0.123878 9.23621 0.150343 9.3133 0.192459C9.39039 0.234574 9.4584 0.291511 9.51342 0.359996C9.57447 0.428543 9.62071 0.508961 9.64924 0.59621C9.67777 0.683459 9.68797 0.77566 9.67921 0.867035C9.67044 0.958411 9.64291 1.04699 9.59832 1.12723C9.55373 1.20747 9.49305 1.27763 9.42008 1.33333L5.42008 4.55333C5.29669 4.63701 5.14882 4.67691 5.00008 4.66666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.3b18e0cc84d7d90b5b96b5f7f69f2dcf.svg";
export { ForwardRef as ReactComponent };